import gsap from 'gsap'
// import { Power2 } from 'gsap'
import koko from '../koko-framework/koko'
import { au } from '../koko-framework/shorthand'
import app from '../koko-framework/app'
// import * as PIXI from 'pixi.js'
import { setupClicker } from '../controller/ButtonController'

export class PPHintView extends koko.view {
    currentGameView = null;

    /* constructor (){
        super();
    } */

    buildView (){
        var vp = app.viewPort;

        this.children = koko.display.buildLayout([
            { type: 'shape', name: 'bg', x: -280, y: 0, width: 1326, height: 1355, fill: 0, alpha: 0.6},

            { type: 'sprite', id: 'pigpen_hintCarrier', name: 'bg2', x: vp.centerX, y: vp.centerY, width: 642, height: 814, anchorX: 0.5, anchorY: 0.5},
            { type: 'sprite', id: 'close_btn', name: 'close_btn', x: 607, y: vp.centerY - 325, width: 75, height: 63, anchorX: 0.5, anchorY: 0.5},
            { type: 'sprite', id: 'hint_title', name: 'title', x: vp.centerX, y: vp.centerY - 275, width: 78, height: 62, anchorX: 0.5, anchorY: 0.5},
            { type: 'sprite', id: 'pigpen_hintImage', name: 'hintimg', x: vp.centerX, y: vp.centerY - 45, width: 580, height: 401, anchorX: 0.5, anchorY: 0.5},
            { type: 'bmptext', text: 'The key was hidden in plain sight all along!\nWhat shape surrounds the letter E? Can you\nsee this shape anywhere in the ciphertext?\n\nCheck your phrase includes real words and\nmakes sense.', font: 'typrighter_small', size: 30, tint: 0, name: 'text', align:'left', x: vp.centerX - 265, y: vp.centerY + 175, anchorX: 0, anchorY: 0},

            /*
            { type: 'sprite', id: 'wronganswer_carrier', name: 'bg2', x: vp.centerX, y: 400, width: 642, height: 333, anchorX: 0.5, anchorY: 0.5},
            { type: 'sprite', id: 'wronganswer_title', name: 'title', x: vp.centerX, y: 343, width: 98, height: 62, anchorX: 0.5, anchorY: 0.5},
            { type: 'bmptext', text: 'That answer wasn\'t quite right,\nhave another go!', font: 'typrighter_small', size: 30, tint: 0, name: 'text', align:'center', x: vp.centerX, y: 408, anchorX: 0.5, anchorY: 0},
            */
        ], this.container);

        this.resize();

        /*
        let event = koko.client.system.isMobile ? 'touchstart' : 'mousedown';
        this.children.close_btn.interactive = true;
        this.children.close_btn.on(event, this.closePop);
        */
    }

    resize () {
        /*
        var vp = app.viewPort;
        let bg = this.children.bg;
        bg.width = vp.width + Math.abs(vp.x) * 4;
        bg.height = vp.height + Math.abs(vp.y) * 4;
        bg.x = vp.centerX - bg.width / 2;
        bg.y = vp.centerY - bg.height / 2;
        */
    }

    transitionIn = (currentGameView = null) => {
        this.currentGameView = currentGameView;
        this.buildView();
        this.show();
        this.enable();
        this.container.alpha = 0;
        gsap.to(this.container, {alpha:1, duration: 0.35, onComplete: this.transitionInDone});

        // setTimeout(this.transitionOut, 2000);

        au.playRandom('pop', 1, 10);
    }

    transitionInDone = () => {
        setupClicker(this.children.close_btn, this.closePop);
    }

    transitionOut = () => {
        if (this.currentGameView && this.currentGameView.popClosed) {
            this.currentGameView.popClosed();
        }

        gsap.to(this.container, {alpha:0, onComplete:this.transitionOutDone, duration: 0.35});
    }

    transitionOutDone = () => {
        // gsap.killAll();
        // this.destroyGameObjects();  
        // game.destroy();
        // game = null;
        this.destroyView();
        this.hide();

        /*
        PIXI.Ticker.shared.stop();
        app.renderer.renderer.plugins.interaction.destroy();

        app.paused = true;
        app.renderer.destroy();
        PIXI.utils.destroyTextureCache();
        */
    }

    closePop = (e) => {
        au.play('button', 1, false);
        if (this.currentGameView && this.currentGameView.popClosed) {
            this.currentGameView.popClosed();
        }
        this.transitionOut();
    }
}